import { render, staticRenderFns } from "./PersonalImages.vue?vue&type=template&id=5452f591&scoped=true"
import script from "./PersonalImages.vue?vue&type=script&lang=js"
export * from "./PersonalImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452f591",
  null
  
)

export default component.exports